import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button } from '@/shared/components/Button';
import { apiClient } from '@/lib/api-client';
import { API_BASE_URL } from '@/lib/constants';
/**
 * Fetches a signed subscription token and shows the webcal:// URL the user can
 * add to Google/Apple/Outlook for an auto-updating calendar. Works for students
 * and professors — pass the matching token endpoint.
 */
export function CalendarSubscribeButton({ tokenEndpoint = '/attendance/student/me/calendar-token', }) {
    const [url, setUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [copied, setCopied] = useState(false);
    const [error, setError] = useState('');
    async function handleSubscribe() {
        setError('');
        setLoading(true);
        try {
            const { token } = await apiClient(tokenEndpoint);
            const base = API_BASE_URL.replace(/^https?:\/\//, 'webcal://');
            const subscriptionUrl = `${base}/attendance/calendar/${token}`;
            setUrl(subscriptionUrl);
            try {
                await navigator.clipboard.writeText(subscriptionUrl);
                setCopied(true);
            }
            catch {
                // Clipboard may be blocked; the URL is shown for manual copy.
            }
        }
        catch {
            setError('No se pudo generar el enlace de suscripción.');
        }
        finally {
            setLoading(false);
        }
    }
    return (_jsxs("div", { className: "flex flex-col items-end gap-1", children: [_jsx(Button, { variant: "ghost", size: "sm", loading: loading, onClick: handleSubscribe, children: "Suscribir (auto-actualiza)" }), url && (_jsxs("div", { className: "max-w-xs text-right", children: [_jsx("p", { className: "break-all text-[11px] text-gray-500 dark:text-gray-400", children: url }), _jsxs("p", { className: "text-[11px] text-gray-400 dark:text-gray-500", children: [copied ? 'Copiado. ' : '', "A\u00F1\u00E1delo en tu calendario como \u201Csuscripci\u00F3n por URL\u201D."] })] })), error && _jsx("p", { role: "alert", className: "text-xs text-red-600 dark:text-red-400", children: error })] }));
}
//# sourceMappingURL=CalendarSubscribeButton.js.map